import { ProfileDto } from './dto/profile.dto';
import { TwoFactorDto } from './dto/two-factor.dto';

export class User {
    public _id: string = '';
    public name: string = '';
    public email: string = '';
    public token: string = '';
    public roles: string[] = [];
    public active: boolean = false;
    public expires: number = 0;
    public language: string = 'de';
    public profile: ProfileDto = new ProfileDto();
    public isSystemAdmin: boolean = false;
    public oidcIdentifier: string = '';
}

export class SessionData {
    public token: string = '';
    public tokenType: string = '';
    public user: User = new User();
    public actor: User | undefined;
    public stage: 'login' | 'twofa' | 'pending' = 'login';
    public isLoggedIn: boolean = false;
    public require2Fa: boolean = false;
    public twofactors: TwoFactorDto[] = [];
}

export function validateEmail(email: string): boolean {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
}
